module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_diamonds-8.65e0d102.svg";